export default __webpack_public_path__ + "static/media/IMG8565.7b7b152f.jpg";